import { render, staticRenderFns } from "./IconManicure.vue?vue&type=template&id=df74ddae&"
import script from "./IconManicure.vue?vue&type=script&lang=js&"
export * from "./IconManicure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports